import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";

import { BackButton, GridColumnType, IViewContainerProps, ViewContainer } from "components/grid";
import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";
import { SettingsViewActions } from "store/views/settings";

interface IDispatchProps {
  onSetFocusedColumn(): void;
}

interface IProps extends IDispatchProps, IWithBreakpointsProps, IViewContainerProps {
  noBackButton?: boolean;
}

const SettingsViewContainer: React.FC<IProps> = ({
  onSetFocusedColumn,
  noBackButton = false,
  isMobile,
  children,
  ...props
}) => {
  const backButton = noBackButton ? <></> : <BackButton onClick={onSetFocusedColumn}>Back</BackButton>;

  return (
    <ViewContainer {...props} stackShowBackButton={isMobile} backButton={backButton} placement="main-content">
      {children}
    </ViewContainer>
  );
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  // @ts-expect-error TS(2345)
  onSetFocusedColumn: () => dispatch(SettingsViewActions.setFocusedColumn({ focusedColumn: GridColumnType.First })),
});

export default withBreakpoints(connect(null, mapDispatchToProps)(SettingsViewContainer));
